import Checkbox, { CheckboxProps } from '@carvana/ds-checkbox';
import { SearchSource } from '@carvana/merch-contracts';
import type React from 'react';
import { useContext, useEffect, useState } from 'react';
import FilterEvents from '~/constants/srp/events';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import useFilterMenuEventSource from '~/hooks/srp/useFilterMenuEventSource';

type OwnProps = CheckboxProps & {
  analyticsAttributes?: Record<string, any>;
  facet: string;
  filter: string | number;
};

export default function FilterCheckbox({
  analyticsAttributes,
  checked,
  facet,
  filter,
  onChange,
  ...rest
}: OwnProps) {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const [isChecked, setChecked] = useState(checked);
  const source = useFilterMenuEventSource();
  const trackEvent = useTrackEvent();

  const onChangeHandler: React.ChangeEventHandler<HTMLInputElement> = ev => {
    setChecked(v => !v);

    trackEvent(FilterEvents.engagedFacet, {
      action: 'clicked',
      actionTaken: `${isChecked ? 'remove' : 'add'}`,
      item: 'checkbox',
      label: facet,
      source,
      value: filter,
      ...analyticsAttributes
    });

    const t = setTimeout(() => {
      setSearchSource(SearchSource.Facet);
      if (onChange) onChange(ev);
    }, 0);

    return () => {
      clearTimeout(t);
    };
  };

  // Synchronize local state with global state
  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  return (
    <Checkbox
      checked={isChecked}
      data-analytics-id={null}
      onChange={onChangeHandler}
      size="small"
      {...rest}
    />
  );
}
